<template>
  <li>
    <div class="cover_wrap">
      <router-link
        :to="{
          name: `${library ? 'library_' : ''}book_detail`,
          params: { id: book.bookCd || book.id, orderId: book.orderId }
        }"
        class="thum_wrap"
      >
        <img :src="book.img || book.thumbUrl" :alt="book.title + ` 책 표지`" />
        <img
          v-if="getRightDays === `대여기간 만료`"
          class="endDate"
          src="@/assets/images/book_end_date.png"
          alt="도서기간만료"
        />
        <img
          v-if="isEbookEvent"
          class="eventMark"
          src="@/assets/images/eventmark2.png"
          alt="이벤트마크"
        />
        <div
          v-show="purchaseLabel && library"
          :class="[
            purchaseLabel === '소장'
              ? 'free_label_2'
              : purchaseLabel === '증정본'
              ? 'free_label_3'
              : purchaseLabel === '체험판'
              ? 'free_label_4'
              : ''
          ]"
          class="free_label"
        >
          {{ purchaseLabel }}
        </div>

        <!-- <div v-show="purchaseLabel" class="use_date">
          {{ book }}
        </div> -->

        <span v-if="book.hasNote === 'Y'" class="iconbox">
          <span class="meta_editer note active">
            <span class="an_t">노트</span>
          </span>
        </span>
      </router-link>
      <div
        v-if="isMoveBookModeEnabled && this.$route.path !== '/'"
        :class="{ select_book: isMoveBookModeEnabled, active: selected }"
        @click="selectThisBook"
      >
        <button type="button" class="btn_select_book"></button>
      </div>
    </div>
    <div class="info_wrap">
      <div v-if="library" class="free_date_wrap">
        <div class="free_date">
          <p>
            <span v-show="book.readRate > 0" style="color: #fff803;">
              {{ book.readRate }}
            </span>
            <span v-show="book.readRate > 0"> %</span>
            <span v-show="book.readRate == '-'">0 %</span>
            진행중
          </p>
          <p class="dueDate_box">
            <span v-show="getRightDays" class="dueDate">
              {{ getRightDays }}
            </span>
            <br />
          </p>
        </div>
      </div>
      <div class="cite_author">
        <router-link
          :to="{
            name: `${library ? 'library_' : ''}book_detail`,
            params: { id: book.bookCd || book.id, orderId: book.orderId }
          }"
        >
          <h3 class="meta_title">{{ book.title || book.bookNm }}</h3>
        </router-link>
        <p v-if="displaySub" class="row">
          <span v-if="book.author" class="meta_author">{{ book.author }}</span>
          <span v-if="book.publisher" class="gap">/</span>
          <span v-if="book.publisher" class="meta_publisher">{{
            book.publisher
          }}</span>
        </p>
      </div>
      <dl v-if="displayPrice" class="meta_price">
        <!-- eslint-disable-next-line -->
        <!-- <div v-if="paperPrice" style="display: flex;"> -->
        <!-- <dt>{{ $t('base.basebook.219') }}</dt> -->
        <!-- Formatted Paper Price -->
        <!-- <dd>
            <vue-intl-numberformat
              locale="ko-KR"
              format-style="currency"
              :currency="getCurrency.currency"
              :number="paperPrice"
            />
          </dd>
        </div> -->
        <!-- eslint-disable-next-line -->
        <div v-if="ebookPrice" class="ebookPrice">
          <!-- Formatted eBook Price -->
          <!-- 대여가 둘중 하나라도 존재하는경우 -->
          <dd
            v-if="
              !isEbookEvent && (ebookPriceRent12 != 0 || ebookPriceRent6 != 0)
            "
          >
            <span class="optsDesc">구매(소장)</span>
            <span class="grayPrice">
              <vue-intl-numberformat
                locale="ko-KR"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="purePrice"
              />원
            </span>
          </dd>
          <!-- 소장만 있는경우 -->
          <div
            v-if="
              !isEbookEvent && ebookPriceRent12 == 0 && ebookPriceRent6 == 0
            "
            class="only_purchase"
          >
            <dd v-if="purePrice === ebookPrice">
              <span class="optsDesc">구매(소장)</span>
              <span class="grayPrice">
                <vue-intl-numberformat
                  locale="ko-KR"
                  format-style="decimal"
                  :currency="getCurrency.currency"
                  :number="purePrice"
                />원
              </span>
            </dd>
            <dd v-else>
              <span class="optsDesc">구매(소장)</span>
              <del class="grayPrice">
                <vue-intl-numberformat
                  locale="ko-KR"
                  format-style="decimal"
                  :currency="getCurrency.currency"
                  :number="purePrice"
                />원
              </del>
            </dd>
            <dd v-if="purePrice !== ebookPrice">
              <span class="blank"><!--소장 가격에서 할인된 가격--></span>
              <img src="@/assets/images/jungga.png" alt="정가할인" />
              <span class="grayPrice" style="color: red;">
                <vue-intl-numberformat
                  locale="ko-KR"
                  format-style="decimal"
                  :currency="getCurrency.currency"
                  :number="ebookPrice"
                />원
              </span>
            </dd>
          </div>
          <!-- 12개월만 존재 -->
          <dd
            v-if="
              !isEbookEvent && ebookPriceRent12 != 0 && ebookPriceRent6 == 0
            "
          >
            <span class="optsDesc">대여(12개월)</span>
            <span>
              <vue-intl-numberformat
                locale="ko-KR"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="ebookPriceRent12"
              />원
            </span>
          </dd>
          <dd v-if="!isEbookEvent && ebookPriceRent6 != 0">
            <span class="optsDesc">대여(6개월)</span>
            <span>
              <vue-intl-numberformat
                locale="ko-KR"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="ebookPriceRent6"
              />원
            </span>
          </dd>
          <dd v-if="isEbookEvent">
            <span class="optsDesc">구매(소장)</span>
            <del class="grayPrice">
              <vue-intl-numberformat
                locale="ko-KR"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="ebookPrice"
              />원
            </del>
          </dd>
          <dd v-if="isEbookEvent" style="color: red;">
            <span class="optsDesc blank"></span>
            <img
              class="optImg"
              src="@/assets/images/jungga.png"
              alt="정가대비"
            />
            <span>
              <vue-intl-numberformat
                locale="ko-KR"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="ebookEvent"
              />원
              <!-- <span>({{ eventPercent }})</span> -->
            </span>
          </dd>
          <!-- {{ isEbookEvent }} -->
        </div>
      </dl>
      <div class="book_desc" :class="{ 'hidden': !landscape }">
        <!-- {{ book.bookDesc }} -->
        {{ bookDescWithoutTag }}
      </div>
    </div>
    <div class="btn_wrap" :class="{ 'hidden': !landscape }">
      <p
        ref="cartArea"
        :class="{ 'hidden': !landscape }"
        class="meta_dscript cart"
        @click="toggleShowOption(0)"
      >
        <!-- <img src="@/assets/images/to_cart.png" /> -->
        장바구니
      </p>
      <OptionList :ref="refName[0]" :book="book" type="cart" />
      <p
        ref="purchaseArea"
        :class="{ 'hidden': !landscape }"
        class="meta_dscript buy"
        @click="toggleShowOption(1)"
      >
        <!-- <img src="@/assets/images/to_buy.png" /> -->
        구매하기
      </p>
      <OptionList :ref="refName[1]" :book="book" type="buy" />
    </div>
    <div class="btn_wrap_mobile">
      <p :class="{ 'hidden': !landscape }" class="meta_dscript detail">
        <router-link
          :to="{
            name: `${library ? 'library_' : ''}book_detail`,
            params: { id: book.bookCd || book.id, orderId: book.orderId }
          }"
        >
          <!-- <img src="@/assets/images/btn_detail_mobile_2.png" /> -->
          상세보기
        </router-link>
      </p>
      <p
        :class="{ 'hidden': !landscape }"
        class="meta_dscript cart"
        @click="toggleShowOptionMobile()"
      >
        <!-- <img src="@/assets/images/btn_cart_mobile_2.png" /> -->
        장바구니
      </p>
      <OptionList :ref="refName[2]" :book="book" type="cart" />
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { UI_SELECT_BOOK, UI_UNSELECT_BOOK } from '@/store/types'
import OptionList from '@/components/common/OptionList'

export default {
  name: 'BaseBook',
  components: {
    OptionList
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    landscape: {
      type: Boolean,
      default: false
    },
    library: {
      type: Boolean,
      default: false
    },
    displayPrice: {
      type: Boolean,
      default: false
    },
    displaySub: {
      type: Boolean,
      default: true
    },
    displayRating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      starSize: 16,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      selectedOption: null,
      refName: ['cart', 'buy', 'mobCart']
    }
  },
  computed: {
    ...mapGetters([
      'isMoveBookModeEnabled',
      'getCurrency',
      'getSelectedLibraryBooks'
    ]),
    purchaseLabel() {
      let x = false
      switch (this.book.purchaseTp) {
        case 'PMT':
          x = '소장'
          break
        case 'PRS':
          x = '증정본'
          break
        case 'RNT':
          x = '대여'
          break
        case 'GFT':
          x = '선물'
          break
        case 'CPN':
          x = '체험판'
          break
        case 'PFF':
          x = '무료'
          break
        default:
          x = '소장'
          break
      }
      return x
    },
    purchaseDueDate() {
      let date = false
      if (this.book.purchaseTp == 'PRS' || this.book.purchaseTp == 'RNT') {
        date = this.book.expDate.replaceAll('-', '/').slice(2)
      } else {
        date = false
      }
      return date
    },
    getRightDays() {
      let left = this.book.rightsDays
      if (left > 0) {
        let formatt =
          left?.toString().lnegth > 1
            ? left.toString()
            : left.toString().padStart(2, '0')

        return `${formatt}일 남음`
      }
      if (left == 0) return `대여기간 만료`
      else return left
    },
    selected() {
      return this.getSelectedLibraryBooks.find((e) => e === this.book.bookCd)
    },
    hasPaper() {
      return this.book.buyTp ? this.book.buyTp.paperbook : false
    },
    hasEbook() {
      return this.book.buyTp ? this.book.buyTp.ebook : false
    },
    hasPod() {
      return this.book.buyTp ? this.book.buyTp.pod : false
    },
    paperPrice() {
      if (!this.book?.bookPrice?.paperbook?.currencies) {
        return this.book.bookPrice?.paperbook?.salePrice
      }
      if (
        this.book.bookPrice &&
        this.book.bookPrice.paperbook &&
        this.book.bookPrice.paperbook.salePrice
      ) {
        const lang = localStorage.getItem('lang')
          ? this.getCurrency.currency
          : 'KRW'

        return this.book.bookPrice.paperbook.currencies.find(
          (e) => e.currencyTp === lang
        ).salePrice
      }
      return 0
    },
    ebookPrice() {
      if (this.book.bookPrice?.ebook?.options) {
        return this.book.bookPrice.ebook.options.find(
          (e) => e.optId === 'OPT-UL'
        )?.salePrice
      }
      if (
        this.book.bookPrice &&
        this.book.bookPrice.ebook &&
        this.book.bookPrice.ebook.salePrice
      ) {
        const lang = localStorage.getItem('lang')
          ? this.getCurrency.currency
          : 'KRW'

        return this.book.bookPrice.ebook.currencies.find(
          (e) => e.currencyTp === lang
        ).salePrice
      }
      return 0
    },
    purePrice() {
      if (this.book.bookPrice?.ebook?.options) {
        return this.book.bookPrice.ebook.options.find(
          (e) => e.optId === 'OPT-UL'
        )?.listPrice
      }
      return 0
    },
    isEbookEvent() {
      // for (let option of this.book.bookPrice.ebook.options) {
      //   console.log(option)
      // }
      let salePrice = this.book?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.salePrice
      let listPrice = this.book?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.listPrice
      if (salePrice < listPrice) {
        return true
      } else {
        return false
      }
    },
    eventPercent() {
      let listPrice = this.ebookPrice
      let salePrice = this.ebookEvent

      return Math.round(((listPrice - salePrice) / listPrice) * 100) + '%'
    },
    ebookEvent() {
      if (this.isEbookEvent) {
        return this.book.bookPrice.ebook.options.find(
          (e) => e.optDesc === '대여(6개월)'
        )?.salePrice
      } else {
        return 0
      }
    },
    ebookPriceRent12() {
      // 12개월 정가
      return (
        this.book.bookPrice.ebook.options.find(
          (e) => e.optDesc === '대여(12개월)'
        )?.listPrice || 0
      )
    },
    ebookPriceRent6() {
      // 6개월 정가
      return (
        this.book.bookPrice.ebook.options.find(
          (e) => e.optDesc === '대여(6개월)'
        )?.listPrice || 0
      )
    },
    ratingScore() {
      if (this.book.rating) {
        return parseFloat(this.book.rating.average || 0)
      }

      if (this.book.rate) {
        return parseFloat(this.book.rate.average || 0)
      }
      return 0
    },
    ratingCount() {
      if (this.book.rating) {
        return parseFloat(this.book.rating.rateCount || 0)
      }

      if (this.book.rate) {
        return parseFloat(this.book.rate.rateCount || 0)
      }
      return 0
    },
    bookDescWithoutTag() {
      if (this.book.bookDesc != null) {
        let res = this.book.bookDesc
        const regdex = /<[^>]*>?/g
        let str = res.replaceAll(regdex, '')
        return str
      }
      return ''
    }
  },
  mounted() {
    document.addEventListener('click', this.checkClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkClickOutside)
  },
  methods: {
    selectThisBook() {
      console.log(this.book)
      // this.selected = !this.selected

      if (!this.selected) {
        console.log(this.book.bookCd, 'selected')
        this.$store.commit(UI_SELECT_BOOK, this.book.bookCd)
      } else {
        console.log(this.book.bookCd, 'unselected')
        this.$store.commit(UI_UNSELECT_BOOK, this.book.bookCd)
      }
    },
    toggleShowOption(val) {
      let comp_cart = this.$refs.cart
      let comp_buy = this.$refs.buy

      switch (val) {
        case 0:
          comp_buy.hideOption()
          comp_cart.toggleShowOption()
          break
        case 1:
          comp_cart.hideOption()
          comp_buy.toggleShowOption()
          break
        default:
          break
      }
    },
    toggleShowOptionMobile() {
      this.$refs.mobCart.toggleShowOption()
    },
    hideOptionMobile() {
      this.$refs.mobCart.hideOption()
    },
    checkClickOutside(event) {
      let cartArea = this.$refs.cartArea
      let purchaseArea = this.$refs.purchaseArea
      // 클릭한 위치가 p 태그 내부인지 확인
      if (!cartArea.contains(event.target)) {
        let comp_cart = this.$refs.cart
        comp_cart.hideOption() // p 태그 영역 외부 클릭 시 옵션 닫기
      }
      if (!purchaseArea.contains(event.target)) {
        let comp_buy = this.$refs.buy
        comp_buy.hideOption() // p 태그 영역 외부 클릭 시 옵션 닫기
      }
    }
  }
}
</script>
<style src="@/assets/css/meta_book_style.css" scoped></style>
<style lang="scss" scoped>
.vue-star-rating {
  width: 90px;
  float: left;
  top: 2px;
  position: relative !important;
}

.meta_rate {
  margin-top: 4px !important;
}
// 2022. 05. 13 추가 개발
.free_label {
  background: #3a89ff;
  height: 18px;
  position: absolute;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 30%);
  left: 7px;
  top: 7px;
  border-radius: 6px;
  text-align: center;
  line-height: 17px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  padding: 0 8px;
  white-space: nowrap;
}
.free_label_2 {
  background: #ff6a85;
}

.free_label_3 {
  background: #aa6aff;
  padding: 0 4px;
}
.free_label_4 {
  background: #1cbf17;
  padding: 0 4px;
}

.free_date_wrap {
  height: 22px;
  background-color: #34ccbe;
  border-radius: 5px;
  border: 1px solid #707070;
  font-size: 11px;
  color: #fff;
  font-weight: 400;
  overflow: hidden;
  margin-bottom: 10px;
}

.free_date {
  text-align: center;
  p {
    line-height: 22px;
    display: inline-block;
    width: 50%;
  }
}
.dueDate_box {
  width: 100%;
  font-weight: 500;
  color: #ff1d00;
  background-color: #fff;
}
.eplist.item_columns_grid {
  .info_wrap {
    .meta_price {
      dd {
        .grayPrice {
          color: #a0a0a0;
        }
      }
    }
  }
}
.eplist.item_columns_grid.item_image .info_wrap {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  height: 125px;
  .meta_price {
    dd {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      white-space: nowrap;
      .optsDesc {
        font-size: 15px;
      }
      .optsDesc.blank {
        width: 50px;
      }
      .optImg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.cite_author {
  min-height: 60px;
}
.only_purchase {
  .blank {
    width: 50px;
  }
  img {
    width: 20px;
    height: 20px;
  }
}
.eplist.item_columns_grid.item_landscape {
  .info_wrap {
    display: block;
    height: unset;
    .meta_price {
      .ebookPrice {
        display: flex;
        flex-direction: column;
      }
      dd {
        align-items: center;
        .optsDesc {
          margin-right: 5px;
        }
        .optImg {
          margin-right: 5px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
// 2022.08.25 추가개발(sam)
.meta_title {
  -webkit-line-clamp: 2 !important;
}
.eplist .thum_wrap .endDate {
  position: absolute;
  top: calc(50% - 35px);
  left: calc(50% - 35px);
  width: 70px;
  height: 70px;
}
.eplist .thum_wrap .eventMark {
  position: absolute;
  // top: calc(5px);
  // left: calc(100% - (55px - 2px));
  // width: 55px;
  // height: 46px;
  top: calc(55px);
  left: calc(100% - (40px - 2px));
  width: 40px;
  height: 36px;
}

.eplist.item_columns_grid.item_landscape .meta_price {
  position: relative;
  // bottom: 0;
  margin-top: 0;
}
.meta_price {
  font-size: 1.55em;
}
.meta_price dt {
  width: 60px;
}
.eplist.item_columns_grid.item_landscape .info_wrap .meta_title {
  display: inline-block;
  width: 630px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1.429em;
  line-height: 1.45em;
  margin-bottom: 4px;
}
.eplist.item_columns_grid.item_landscape .meta_dscript {
  display: inline-block;
  // margin-right: 10px;
  margin-top: 0px;
}
.eplist.item_columns_grid.item_landscape .meta_dscript a {
  display: inline;
}
.eplist.item_columns_grid.item_landscape .btn_wrap {
  display: grid;
  grid-template-columns: 200px;
  grid-template-rows: 43px 10px 43px 10px;
  justify-content: end;
  justify-items: end;

  //  position: relative;
  //  bottom: 98px;
  position: absolute;
  top: 40px;
  right: 0px;
  .meta_dscript {
    width: 192px;
    grid-column-start: 1;
    grid-column-end: 2;
    text-align: center;
    font-size: 20px;
    line-height: 41px;
    background-color: #008df3;
    cursor: pointer;
    user-select: none;
    color: #ffffff;
  }
  .meta_dscript.cart {
    grid-row-start: 1;
    grid-row-end: 2;
  }
  .meta_dscript.buy {
    grid-row-start: 3;
    grid-row-end: 4;
  }
  .option {
    display: block;
  }
  .detail {
    display: none;
  }
  .price_list.cart {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
  }
  .price_list.buy {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 4;
    grid-row-end: 5;
  }
}
.book_desc {
  margin-top: 30px;
  width: 40%;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
@media all and (min-width: 768px) {
  .btn_wrap_mobile {
    display: none;
  }
}
@media all and (max-width: 767px) {
  .eplist.item_columns_grid.item_landscape .item_list > li {
    padding-left: 120px;
    height: 150px;
  }
  .eplist.item_columns_grid.item_landscape .cover_wrap {
    width: 105px;
    max-height: 150px;
  }
  .eplist.item_columns_grid.item_landscape .thum_wrap,
  .eplist.item_columns_grid.item_landscape .thum_wrap img {
    max-height: 150px;
  }
  .eplist.item_columns_grid.item_image .info_wrap {
    height: unset;
  }
  .meta_author,
  .meta_publisher {
    font-size: 13px;
    line-height: 15px;
  }
  .meta_author,
  .meta_publisher {
    height: 18px;
  }
  .eplist.item_columns_grid .info_wrap .meta_title {
    font-size: 14px;
  }
  // .eplist.item_columns_grid.item_image .info_wrap .meta_title {
  //   -webkit-line-clamp: 1 !important;
  // }
  .eplist.item_columns_grid.item_landscape .info_wrap .meta_title {
    font-size: 15px;
  }
  .eplist.item_columns_grid.item_image .info_wrap .meta_price {
    display: inline-block;
    dd {
      margin-bottom: 5px;
    }
  }
  .eplist.item_columns_grid.item_landscape {
    .info_wrap {
      .gap {
        display: none;
      }
      .meta_publisher {
        display: none;
      }
      .meta_price {
        bottom: 0px;
        width: unset;
        height: 45px;
        .ebookPrice {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: inherit;
        }
        dd {
          font-size: 15px;
          position: unset;
        }
      }
    }
    .btn_wrap {
      display: none;
    }
    .btn_wrap_mobile {
      display: grid;
      grid-template-columns: 110px 100px;
      grid-template-rows: 33px 33px;
      position: relative;
      top: 20px;
      .meta_dscript {
        width: 100px;
        background-color: #008df3;
        &.cart {
          display: block;
          height: 100%;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #fff;
        }
        a {
          display: block;
          height: 100%;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #fff;
        }
      }
      .price_list.cart {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 2;
        grid-row-end: 3;
      }
    }
    .book_desc {
      display: none;
    }
  }
  .cite_author {
    min-height: 30px;
  }
}
@media (max-width: 480px) {
  .eplist.item_columns_grid.item_landscape .info_wrap .meta_title {
    width: 233px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cite_author {
    min-height: 25px;
  }
}
</style>
